import {ReactElement} from 'react'
import {Credits, CreditsActive, MyFavorites, MyFavoritesActive, MyMessages, MyMessagesActive, People, PeopleActive, Profile, ProfileActive} from './img/icons'

type SidebarKeys = 'people' | 'messages' | 'favorites' | 'credits' | 'profile'

export type SidebarItem = {
  id: SidebarKeys,
  key: number,
  text: string;
  tooltip: string;
  to: string;
  iconDefault: ReactElement;
  iconActive: ReactElement;
}

export const sidebarItems: Record<SidebarKeys, SidebarItem> = {
  people: {
    id: 'people',
    key: 1,
    text: 'People',
    tooltip: 'People',
    to: '/people',
    iconDefault: <People />,
    iconActive: <PeopleActive />,
  },
  messages: {
    id: 'messages',
    key: 2,
    text: 'My Messages',
    tooltip: 'Messages',
    to: '/messages',
    iconDefault: <MyMessages />,
    iconActive: <MyMessagesActive />,
  },
  favorites: {
    id: 'favorites',
    key: 3,
    text: 'My Favorites',
    tooltip: 'Favorites',
    to: '/favorites',
    iconDefault: <MyFavorites />,
    iconActive: <MyFavoritesActive />,
  },
  credits: {
    id: 'credits',
    key: 4,
    text: 'Credits',
    tooltip: 'Credits',
    to: '/credits',
    iconDefault: <Credits />,
    iconActive: <CreditsActive />,
  },
  profile: {
    id: 'profile',
    key: 5,
    text: 'My profile',
    tooltip: 'Profile',
    to: '/myProfile',
    iconDefault: <Profile />,
    iconActive: <ProfileActive />,
  },
}

export const sidebarList = Object.values(sidebarItems).sort((a, b) => a.key - b.key)